// import React, {useState} from "react";
// import {Link} from "react-router-dom";
// import {Button} from "@material-ui/core";
// import logo from "../image/logo.webp";
// import Darklogo from "../image/beleaf_dark.webp";

// function HeaderNew() {
//   const [navbar, setNavbar] = useState(false);

//   const changeHeader = () => {
//     if (window.scrollY >= 80) {
//       setNavbar(true);
//     } else {
//       setNavbar(false);
//     }
//   };
//   window.addEventListener("scroll", changeHeader);

//   return (
//     <>
//       <header>
//         <nav className="header_section ">
//           <div className="container">
//             <nav
//               className={
//                 navbar
//                   ? "navbar-custom sticky sticky-dark  navbar navbar-expand-lg fixed-top fixed_header"
//                   : "navbar-custom sticky sticky-dark  navbar navbar-expand-lg fixed-top "
//               }
//             >
//               <div className="container-fluid">
//                 <a href="/" className="logo text-uppercase navbar-brand">
//                   {/* <img src={logo} className="img-fluid dark_logo" /> */}
//                   <img
//                     src={Darklogo}
//                     className="img-fluid dark_logo"
//                     alt="logo"
//                   />

//                   <img
//                     src={Darklogo}
//                     className="img-fluid white_logo"
//                     alt="logo"
//                   />
//                 </a>
//                 <button
//                   className="navbar-toggler"
//                   type="button"
//                   data-toggle="collapse"
//                   data-target="#navbarNavDropdown"
//                   aria-controls="navbarNavDropdown"
//                   aria-expanded="false"
//                   aria-label="Toggle navigation"
//                 >
//                   <i className="fa fa-bars" aria-hidden="true"></i>
//                 </button>
//                 <div
//                   id="navbarNavDropdown"
//                   className="collapse navbar-collapse"
//                 >
//                   <div data-nav="list" className="navbar-collapse">
//                     <ul
//                       id="mySidenav"
//                       className="ml-auto navbar-center navbar-nav"
//                     >
//                       <div>
//                         <a
//                           href="#Crypto"
//                           data-toggle="collapse"
//                           className="collaps_menue"
//                         >
//                           Crypto Solutions
//                         </a>

//                         <div
//                           id="Crypto"
//                           className="collapse collaps_menue_contnt"
//                         >
//                           <div className="container">
//                             <div className="menu_wrap">
//                               <div className="menueee">
//                                 <div
//                                   to="/cryptocurrency-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Centralized Crypto Exchange
//                                 </div>
//                                 <div
//                                   // to="/decentralized-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   P2P Trading Development
//                                 </div>
//                                 <div
//                                   to="/nft-development-solutions"
//                                   className="dropdown-item"
//                                 >
//                                   Margin Trading Development
//                                 </div>
//                                 <div
//                                   to="/p2p-cryptocurrency-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Futures Trading Development
//                                 </div>
//                                 <div
//                                   to="/ico-development"
//                                   className="dropdown-item"
//                                 >
//                                   Perpetual Trading Development
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/ieo-development"
//                                   className="dropdown-item"
//                                 >
//                                   Copy Trading Development
//                                 </div>
//                                 <div
//                                   to="/crypto-derivatives-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Options Trading Development
//                                 </div>
//                                 <div
//                                   to="/market-making-bot"
//                                   className="dropdown-item"
//                                 >
//                                   Strategy Trading Development
//                                 </div>
//                                 <div to="/arbitrage" className="dropdown-item">
//                                   Instant Exchange Development
//                                 </div>
//                                 <div
//                                   to="/smart-order-routing"
//                                   className="dropdown-item"
//                                 >
//                                   Lending and Borrowing Development
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/over-the-counter"
//                                   className="dropdown-item"
//                                 >
//                                   OTC Exchange Development
//                                 </div>
//                                 <div
//                                   to="/whitelabel-crypto-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Launchpad Platform Development
//                                 </div>
//                                 <div
//                                   to="/local-bitcoin-clone"
//                                   className="dropdown-item"
//                                 >
//                                   Fixed Staking Development
//                                 </div>
//                                 <div
//                                   to="/payment-gate-way"
//                                   className="dropdown-item"
//                                 >
//                                   Flexible Staking Development
//                                 </div>
//                                 <div
//                                   to="/blockchain-based-social-media-platforms"
//                                   className="dropdown-item"
//                                 >
//                                   Whitelabel Crypto Exchange Development
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       <div>
//                         <a
//                           href="#Dex"
//                           data-toggle="collapse"
//                           className="collaps_menue"
//                         >
//                           DeFi & DEX
//                         </a>
//                         <div id="Dex" className="collapse collaps_menue_contnt">
//                           <div className="container">
//                             <div className="menu_wrap">
//                               <div className="menueee">
//                                 <div
//                                   to="/cryptocurrency-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   PancakeSwap Clone Script
//                                 </div>
//                                 <div
//                                   to="/decentralized-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Uniswap Clone Script
//                                 </div>
//                                 <div
//                                   to="/nft-development-solutions"
//                                   className="dropdown-item"
//                                 >
//                                   DexGuru Clone Script
//                                 </div>
//                                 <div
//                                   to="/p2p-cryptocurrency-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Quickswap Clone Script
//                                 </div>
//                                 <div
//                                   to="/ico-development"
//                                   className="dropdown-item"
//                                 >
//                                   dYdX Clone Script
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/ieo-development"
//                                   className="dropdown-item"
//                                 >
//                                   1inch Clone Script
//                                 </div>
//                                 <div
//                                   to="/crypto-derivatives-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   yearn.finance Clone Script
//                                 </div>
//                                 <div
//                                   to="/market-making-bot"
//                                   className="dropdown-item"
//                                 >
//                                   Safemoon Clone Script
//                                 </div>
//                                 <div to="/arbitrage" className="dropdown-item">
//                                   BakerySwap Clone Script
//                                 </div>
//                                 <div
//                                   to="/smart-order-routing"
//                                   className="dropdown-item"
//                                 >
//                                   DeFi Staking platform Development
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/over-the-counter"
//                                   className="dropdown-item"
//                                 >
//                                   DeFi Token Development
//                                 </div>
//                                 <div
//                                   to="/whitelabel-crypto-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   panKUKU Clone Script
//                                 </div>
//                                 <div
//                                   to="/local-bitcoin-clone"
//                                   className="dropdown-item"
//                                 >
//                                   Sushiswap Clone Script
//                                 </div>
//                                 <div
//                                   to="/payment-gate-way"
//                                   className="dropdown-item"
//                                 >
//                                   Dinoswap Clone Script
//                                 </div>
//                                 <div
//                                   to="/blockchain-based-social-media-platforms"
//                                   className="dropdown-item"
//                                 >
//                                   JustSwap Clone Script
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       <div>
//                         <a
//                           href="#NFT"
//                           data-toggle="collapse"
//                           className="collaps_menue"
//                         >
//                           NFT
//                         </a>
//                         <div id="NFT" className="collapse collaps_menue_contnt">
//                           <div className="container">
//                             <div className="menu_wrap">
//                               <div className="menueee">
//                                 <div
//                                   to="/cryptocurrency-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace Development
//                                 </div>
//                                 <div
//                                   to="/decentralized-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Gaming Development
//                                 </div>
//                                 <div
//                                   to="/nft-development-solutions"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace on Etherum
//                                 </div>
//                                 <div
//                                   to="/p2p-cryptocurrency-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace on MATIC
//                                 </div>
//                                 <div
//                                   to="/ico-development"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace on BSC
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/ieo-development"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace on ASTAR
//                                 </div>
//                                 <div
//                                   to="/crypto-derivatives-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace on Avalanche
//                                 </div>
//                                 <div
//                                   to="/market-making-bot"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace on side chain
//                                 </div>
//                                 <div to="/arbitrage" className="dropdown-item">
//                                   Marketplace on Solana
//                                 </div>
//                                 <div
//                                   to="/smart-order-routing"
//                                   className="dropdown-item"
//                                 >
//                                   Marketplace on Harmony
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/over-the-counter"
//                                   className="dropdown-item"
//                                 >
//                                   Staking platform
//                                 </div>
//                                 <div
//                                   to="/whitelabel-crypto-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Markletplace Rental platform
//                                 </div>
//                                 <div
//                                   to="/local-bitcoin-clone"
//                                   className="dropdown-item"
//                                 >
//                                   Dancing Platform
//                                 </div>
//                                 <div
//                                   to="/payment-gate-way"
//                                   className="dropdown-item"
//                                 >
//                                   Art Platform
//                                 </div>
//                                 <div
//                                   to="/blockchain-based-social-media-platforms"
//                                   className="dropdown-item"
//                                 >
//                                   Sports, Audio Platforms
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       <div>
//                         <a
//                           href="#token"
//                           data-toggle="collapse"
//                           className="collaps_menue"
//                         >
//                           Token
//                         </a>
//                         <div
//                           id="token"
//                           className="collapse collaps_menue_contnt"
//                         >
//                           <div className="container">
//                             <div className="menu_wrap">
//                               <div className="menueee">
//                                 <div
//                                   to="/cryptocurrency-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   ICO Token Development
//                                 </div>
//                                 <div
//                                   to="/decentralized-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   IEO Token Development
//                                 </div>
//                                 <div
//                                   to="/nft-development-solutions"
//                                   className="dropdown-item"
//                                 >
//                                   IDO Token Development
//                                 </div>
//                                 <div
//                                   to="/p2p-cryptocurrency-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   ETO Token Development
//                                 </div>
//                                 <div
//                                   to="/ico-development"
//                                   className="dropdown-item"
//                                 >
//                                   IPO Token Development
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/ieo-development"
//                                   className="dropdown-item"
//                                 >
//                                   IGO Token Development
//                                 </div>
//                                 <div
//                                   to="/crypto-derivatives-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   IFO Token Development
//                                 </div>
//                                 <div
//                                   to="/market-making-bot"
//                                   className="dropdown-item"
//                                 >
//                                   ILO Token Development
//                                 </div>
//                                 <div to="/arbitrage" className="dropdown-item">
//                                   STO Token Development
//                                 </div>
//                                 <div
//                                   to="/smart-order-routing"
//                                   className="dropdown-item"
//                                 >
//                                   INO Token Development
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/over-the-counter"
//                                   className="dropdown-item"
//                                 >
//                                   ERC20 Token Development
//                                 </div>
//                                 <div
//                                   to="/whitelabel-crypto-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   ERC721 Token Development
//                                 </div>
//                                 <div
//                                   to="/local-bitcoin-clone"
//                                   className="dropdown-item"
//                                 >
//                                   ERC1155 Token Development
//                                 </div>
//                                 <div
//                                   to="/payment-gate-way"
//                                   className="dropdown-item"
//                                 >
//                                   ERC827 Token Development
//                                 </div>
//                                 <div
//                                   to="/blockchain-based-social-media-platforms"
//                                   className="dropdown-item"
//                                 >
//                                   ERC1400 Token Development
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       <div>
//                         <a
//                           href="#script"
//                           data-toggle="collapse"
//                           className="collaps_menue"
//                         >
//                           Clone Script
//                         </a>
//                         <div
//                           id="script"
//                           className="collapse collaps_menue_contnt"
//                         >
//                           <div className="container">
//                             <div className="menu_wrap">
//                               <div className="menueee">
//                                 <div
//                                   to="/cryptocurrency-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Binance Clone Script
//                                 </div>
//                                 <div
//                                   to="/decentralized-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Coinbase Clone Script
//                                 </div>
//                                 <div
//                                   to="/nft-development-solutions"
//                                   className="dropdown-item"
//                                 >
//                                   Kraken Clone Script
//                                 </div>
//                                 <div
//                                   to="/p2p-cryptocurrency-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Wazirx Clone Script
//                                 </div>
//                                 <div
//                                   to="/ico-development"
//                                   className="dropdown-item"
//                                 >
//                                   BitPay Clone Script
//                                 </div>
//                               </div>
//                               <div className="menueee">
//                                 <div
//                                   to="/ieo-development"
//                                   className="dropdown-item"
//                                 >
//                                   Poloniex Clone Script
//                                 </div>
//                                 <div
//                                   to="/crypto-derivatives-exchange-development"
//                                   className="dropdown-item"
//                                 >
//                                   Bitsmap Clone Script
//                                 </div>
//                                 <div
//                                   to="/market-making-bot"
//                                   className="dropdown-item"
//                                 >
//                                   Remitano Clone Script
//                                 </div>
//                                 <div to="/arbitrage" className="dropdown-item">
//                                   Kucoin Clone Script
//                                 </div>
//                                 <div
//                                   to="/smart-order-routing"
//                                   className="dropdown-item"
//                                 >
//                                   IDEX Clone Script
//                                 </div>
//                               </div>

//                               <div className="menueee">
//                                 <div
//                                   to="/over-the-counter"
//                                   className="dropdown-item"
//                                 >
//                                   OpenSea Clone Script
//                                 </div>
//                                 <div
//                                   to="/whitelabel-crypto-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Rarible Clone Script
//                                 </div>
//                                 <div
//                                   to="/local-bitcoin-clone"
//                                   className="dropdown-item"
//                                 >
//                                   Foundation Clone Script
//                                 </div>
//                                 <div
//                                   to="/payment-gate-way"
//                                   className="dropdown-item"
//                                 >
//                                   SuperRare Clone Script
//                                 </div>
//                                 <div
//                                   to="/blockchain-based-social-media-platforms"
//                                   className="dropdown-item"
//                                 >
//                                   CryptoPunks Clone Script
//                                 </div>
//                               </div>

//                               <div className="menueee">
//                                 <div
//                                   to="/over-the-counter"
//                                   className="dropdown-item"
//                                 >
//                                   Solanart Clone Script
//                                 </div>
//                                 <div
//                                   to="/whitelabel-crypto-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   Solsea Clone Script
//                                 </div>
//                                 <div
//                                   to="/local-bitcoin-clone"
//                                   className="dropdown-item"
//                                 >
//                                   Foundation Clone Script
//                                 </div>
//                                 <div
//                                   to="/payment-gate-way"
//                                   className="dropdown-item"
//                                 >
//                                   SuperRare Clone Script
//                                 </div>
//                                 <div
//                                   to="/blockchain-based-social-media-platforms"
//                                   className="dropdown-item"
//                                 >
//                                   CryptoPunks Clone Script
//                                 </div>
//                               </div>

//                               <div className="menueee">
//                                 <div
//                                   to="/over-the-counter"
//                                   className="dropdown-item"
//                                 >
//                                   Paxful Clone Script
//                                 </div>
//                                 <div
//                                   to="/whitelabel-crypto-exchange"
//                                   className="dropdown-item"
//                                 >
//                                   LocalBitcoins Clone Script
//                                 </div>
//                                 <div
//                                   to="/local-bitcoin-clone"
//                                   className="dropdown-item"
//                                 >
//                                   HODL Clone Script
//                                 </div>
//                                 <div
//                                   to="/payment-gate-way"
//                                   className="dropdown-item"
//                                 >
//                                   LocalCoinSwap Clone Script
//                                 </div>
//                                 <div
//                                   to="/blockchain-based-social-media-platforms"
//                                   className="dropdown-item"
//                                 >
//                                   BISQ Clone Script
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* <li className="nav-item active dropdown"></li>
//                       <li className="nav-item active dropdown">
//                         <Link
//                           to=""
//                           className="nav-link active dropdown-toggle"
//                           id="navbarDropdownMenuLink"
//                           role="button"
//                           data-toggle="dropdown"
//                           aria-haspopup="true"
//                           aria-expanded="false"
//                         >
//                           {" "}
//                         </Link>
//                         <div
//                           className="dropdown-menu"
//                           aria-labelledby="navbarDropdownMenuLink"
//                         >
//                           <Link
//                             to="/cryptocurrency-exchange-development"
//                             className="dropdown-item"
//                           >
//                             Centralized Exchange Development
//                           </Link>
//                           <Link
//                             to="/decentralized-exchange-development"
//                             className="dropdown-item"
//                           >
//                             Decentralized Exchange Development
//                           </Link>
//                           <Link
//                             to="/nft-development-solutions"
//                             className="dropdown-item"
//                           >
//                             Development Solutions
//                           </Link>
//                           <Link
//                             to="/p2p-cryptocurrency-exchange"
//                             className="dropdown-item"
//                           >
//                             P2P Cryptocurrency Exchange
//                           </Link>
//                           <Link to="/ico-development" className="dropdown-item">
//                             ICO Development
//                           </Link>
//                           <Link to="/ieo-development" className="dropdown-item">
//                             IEO Development
//                           </Link>
//                           <Link
//                             to="/crypto-derivatives-exchange-development"
//                             className="dropdown-item"
//                           >
//                             Crypto Derivatives Exchange development
//                           </Link>
//                           <Link to="/market-making-bot" className="dropdown-item">
//                             Market Making Bot
//                           </Link>
//                           <Link to="/arbitrage" className="dropdown-item">
//                             Arbitrage Bot
//                           </Link>
//                           <Link to="/smart-order-routing" className="dropdown-item">
//                             Smart Order Routing (SOR)
//                           </Link>
//                           <Link to="/over-the-counter" className="dropdown-item">
//                             Over-the-Counter (OTC)
//                           </Link>
//                           <Link
//                             to="/whitelabel-crypto-exchange"
//                             className="dropdown-item"
//                           >
//                             Whitelabel Crypto Exchange
//                           </Link>
//                           <Link to="/local-bitcoin-clone" className="dropdown-item">
//                             Local Bitcoin Clone
//                           </Link>
//                           <Link to="/payment-gate-way" className="dropdown-item">
//                             Payment Gate way
//                           </Link>
//                           <Link
//                             to="/blockchain-based-social-media-platforms"
//                             className="dropdown-item"
//                           >
//                             Blockchain Based Social Media Platforms
//                           </Link>
//                         </div>
//                       </li> */}

//                       {/* <li className="nav-item active dropdown">
//                         <Link
//                           to=""
//                           className="nav-link active dropdown-toggle"
//                           id="navbarDropdownMenuLink"
//                           role="button"
//                           data-toggle="dropdown"
//                           aria-haspopup="true"
//                           aria-expanded="false"
//                         >
//                           {" "}
//                           Trading Bot
//                         </Link>
//                         <div
//                           className="dropdown-menu"
//                           aria-labelledby="navbarDropdownMenuLink"
//                         >
//                           <a className="dropdown-item">Arbitrage Bot</a>
//                           <a className="dropdown-item">Market Making Bot</a>
//                         </div>
//                       </li> */}

//                       {/* <li className="nav-item">
//                         <Link to="" className="nav-link">
//                           {" "}
//                           Our Service
//                         </Link>
//                       </li> */}

//                       {/* <li className="nav-item">
//                         <Link to="/" className="nav-link">
//                           {" "}
//                           Contact
//                         </Link>
//                       </li> */}

//                       {/* <li className="nav-item">
//                         <Link to="/career" className="nav-link">
//                           Career
//                         </Link>
//                       </li> */}
//                       <li className="nav-item">
//                         <a
//                           href="https://join.skype.com/invite/wg5IW8g4Uaca"
//                           target="_blank"
//                           className="nav-link socoal blob"
//                         >
//                           <i className="bi bi-skype"></i>
//                         </a>
//                       </li>
//                       <li className="nav-item">
//                         <a
//                           href="https://t.me/BeleafTechnologies"
//                           target="_blank"
//                           className="nav-link socoal blob"
//                         >
//                           <i className="bi bi-telegram"></i>
//                         </a>
//                       </li>
//                       <li className="nav-item">
//                         <a
//                           href=" https://wa.me/8056786622"
//                           target="_blank"
//                           className="nav-link socoal blob"
//                         >
//                           <i className="bi bi-whatsapp"></i>
//                         </a>
//                       </li>

//                       <li className="nav-item banner_text_section p-0">
//                         <Button
//                           className="m-0 blob"
//                           data-toggle="modal"
//                           data-target="#myModal"
//                         >
//                           Get Free Quote
//                         </Button>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </nav>
//           </div>
//         </nav>
//       </header>
//     </>
//   );
// }

// export default HeaderNew;
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Darklogo from "../image/beleaf_dark.webp";
import {
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  megaMenu: {
    position: "fixed",
    top: theme.spacing(8),
    left: 0,
    width: "100%",
    maxHeight: "calc(100vh - 76px)",
    minHeight: "calc(100vh - 76px)",

    overflowY: "auto",
    backgroundColor: theme.palette.background.paper,
    // boxShadow: theme.shadows[2],
    zIndex: 555,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    "& > div": {
      marginBottom: theme.spacing(2),
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  mobileMenu: {
    width: 300,
  },
  accordion: {
    marginBottom: theme.spacing(1),
  },
  headerFixed: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 555,
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [headerFixed, setHeaderFixed] = useState(false);

  const handleMenuOpen = (event) => {
    if (anchorEl === event.currentTarget) {
      handleMenuClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const handleDrawerOptionClick = () => {
    setMobileMenuOpen(false);
  };

  const handleScroll = () => {
    const isFixed = window.pageYOffset > 0;
    setHeaderFixed(isFixed);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [activeTab, setActiveTab] = useState("home");

  const handleTabHover = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="header_new_mega">
      <div className={classes.root}>
        <AppBar
          position={headerFixed ? "fixed" : "static"}
          className={`${classes.headerFixed} ${
            headerFixed ? "customClassName" : ""
          }`}
        >
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              <div className="logo_new_sectio">
                <a href="/">
                  <img src={Darklogo} className="img-fluid " alt="logo" />
                </a>
              </div>
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              className={`${classes.mobileMenuButton} mobiele_icon`}
              onClick={handleMobileMenuOpen}
            >
              <MenuIcon />
            </IconButton>
            <div className="menu_new_typr">
              <Button color="inherit" onClick={handleMenuOpen}>
                Services{" "}
                <span>
                  <i className="ri-arrow-down-s-fill"></i>
                </span>
              </Button>
              <Button color="inherit">
                <a href="/blog_details">Blog</a>
              </Button>
              <Button color="inherit">
                <a href="/career">Career</a>
              </Button>
              <a href="/contact-us" color="inherit" className="contact_button">
                Contact Us
              </a>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          anchor="left"
          open={mobileMenuOpen}
          onClose={handleMobileMenuClose}
        >
          <div className={classes.mobileMenu}>
            <div className="logo_new_sectio mobile_menu_icon">
              <a href="/">
                {" "}
                <img src={Darklogo} className="img-fluid " alt="logo" />
              </a>
            </div>
            <List>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Crypto Solutions</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/white-label-cryptocurrency-exchange-software">
                        White label Crypto Exchange
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/cryptocurrency-exchange-development-company">
                        Cryptocurrency Exchange Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/centralized-cryptocurrency-exchange-development">
                        Centralized Crypto Exchange Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/decentralized-cryptocurrency-exchange-development">
                        Decentralized Exchange Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/p2p-cryptocurrency-exchange-development-company">
                        P2P Exchange Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-payment-gateway-development-services">
                        Crypto-Payment Gateway Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/cryptocurrency-exchange-script">
                        Cryptocurrency Exchange Clone Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-launchpad-development-company">
                        Crypto Launchpad Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/cryptocurrency-mlm-software-development">
                        Cryptocurrency MLM Software Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-otc-trading-platform-development">
                        OTC Platform Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-wallet-app-development">
                        Crypto Wallet Development Company
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>

              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Crypto Listing</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-listing-agency">Crypto Listing Agency</a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>

              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Crypto Consulting Agency</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/vara-license-consultant">
                        VARA License Consultant
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>

              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Forex Solutions</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/forex-trading-software-development">
                        Forex Trading Software Development
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>

              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>NFT marketplace</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/nft-marketplace-development-service">
                        NFT MarketPlace Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/nft-game-development-company">
                        NFT Gaming Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/metaverse-nft-marketplace-development-company">
                        Metaverse NFT MarketPlace Development
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Clone Script</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="binance-clone-script-development">
                        Binance Clone Script
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/opensea-clone-script">OpenSea Clone Script</a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/rarible-clone-script">Rarible Clone Script</a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/coinbase-clone-script">
                        Coinbase Clone script development
                      </a>
                    </ListItem>

                    <ListItem button className="accordio_menu_button">
                      <a href="/paxful-clone-script-development-company">
                        Paxful Clone Script Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/wazirx-clone-script-development">
                        WazirX Clone Script Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/local-bitcoin-clone">
                        Localbitcoin Clone Script Development
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Defi Solutions</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/defi-development-company">
                        Defi Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/defi-staking-platform-development">
                        Defi Staking Platform{" "}
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/pancakeswap-clone-script-development">
                        Pancake Swap Clone Script
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Blockchain Solutions</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/blockchain-based-carbon-credit-platform-development">
                        Blockchain Based Carbon Credit Platform Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/dapp-development-company">
                        dApp Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/bitcoin-mining-software-development">
                        Bitcoin Mining Software Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/own-blockchain-development-company">
                        Own Blockchain Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/enterprise-blockchain-development-company">
                        Enterprise Blockchain Development Company
                      </a>
                    </ListItem>

                    <ListItem button className="accordio_menu_button">
                      <a href="/smart-contract-auditing-service-company">
                        Smart Contract Audit
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/dao-development-company">
                        DAO Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/cardano-blockchain-development-company">
                        Cardano Blockchain Development Company
                      </a>
                    </ListItem>
                    {/* <ListItem button className="accordio_menu_button">
                      <a href="/blockchain-social-media-platform-development">
                        Blockchain Social Media Platform Development
                      </a>
                    </ListItem> */}
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Trading Bot Development</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-arbitrage-trading-bot">
                        Arbitrage Bot Development
                      </a>
                    </ListItem>

                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-smart-order-routing-services">
                        Smart Order Routing Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-market-making-services">
                        Crypto Market Making Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/mev-bot-development-company">
                        MEV Bot Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-algo-trading-bot-development">
                        Algo Trading Software Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-trading-bot-development-company">
                        Crypto Trading Bot Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-flash-loan-arbitrage-bot-development">
                        Flash Loan Arbitrage Bot Development
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Token Development</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/token-development-company">
                        Crypto Token Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/meme-coin-development-company">
                        Meme Coin Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/stablecoin-development-company">
                        Stablecoin Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/ico-development-company">
                        ICO Token Development
                      </a>
                    </ListItem>
                    {/* <ListItem button className="accordio_menu_button">
                      <a href="/ieo-development-company">
                        IEO Token Development
                      </a>
                    </ListItem> */}
                    <ListItem button className="accordio_menu_button">
                      <a href="/sto-development-company">
                        STO Token Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/central-bank-digital-currency-development-company">
                        Central Bank Digital Currency Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/real-world-asset-token-development">
                        Real World Asset Token Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/solana-meme-coin">
                        Solana Meme Coin Development
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/semi-fungible-token-development">
                        Semi Fungible Token Development
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Web3 Solutions</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/web3-development-solution">Web3 Solutions</a>
                    </ListItem>

                    <ListItem button className="accordio_menu_button">
                      <a href="/metaverse-development-company">
                        Metaverse Development Company
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>AI And ML development solutions</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/ai-and-ml-development-company">
                        AI And ML development solutions
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/generative-ai-development-company">
                        Generative AI Development
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>
              <Accordion className={`${classes.accordion} acrdion`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="inner_text_accoridion"
                >
                  <p>Game Development</p>
                </AccordionSummary>
                <AccordionDetails className="display_accodion">
                  <List>
                    <ListItem button className="accordio_menu_button">
                      <a href="/crypto-casino-game-development">
                        Crypto Casino Game Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/betfury-clone-script-development-company">
                        Betfury Clone Script Development Company
                      </a>
                    </ListItem>
                    <ListItem button className="accordio_menu_button">
                      <a href="/blockchain-game-development">
                        Blockchain Game Development Company
                      </a>
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>

              <div className="menu_statis">
                <ListItem
                  button
                  onClick={handleDrawerOptionClick}
                  className="accordio_menu_button"
                >
                  <a href="/blog_details">Blog</a>
                </ListItem>
                <ListItem
                  button
                  onClick={handleDrawerOptionClick}
                  className="accordio_menu_button"
                >
                  <a href="/career">Career</a>
                </ListItem>
                <ListItem
                  button
                  onClick={handleDrawerOptionClick}
                  className="accordio_menu_button"
                >
                  <a href="/contact-us">Contact Us</a>
                </ListItem>
              </div>
            </List>
          </div>
        </Drawer>

        {anchorEl && (
          <div className={classes.megaMenu} onMouseLeave={handleMenuClose}>
            <div className="container-fluid">
              <div>
                <div className="row">
                  <div className="col-lg-3">
                    <ul className="nav nav-tabs header_menu">
                      <li
                        className={activeTab === "home" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("home")}
                      >
                        <a data-toggle="tab" href="#home">
                          Crypto Solutions{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "home" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("Listing")}
                      >
                        <a data-toggle="tab" href="#Listing">
                          Crypto Listing Agency{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "home" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("Consulting")}
                      >
                        <a data-toggle="tab" href="#Consulting">
                          Crypto Consulting Agency{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "home" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("forex")}
                      >
                        <a data-toggle="tab" href="#forex">
                          Forex Solutions{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "menu1" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu1")}
                      >
                        <a data-toggle="tab" href="#menu1">
                          NFT Marketplace{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "menu7" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu7")}
                      >
                        <a data-toggle="tab" href="#menu7">
                          Clone Script
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "menu3" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu3")}
                      >
                        <a data-toggle="tab" href="#menu3">
                          Defi Solutions
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "menu4" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu4")}
                      >
                        <a data-toggle="tab" href="#menu4">
                          Blockchain Solutions
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "menu5" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu5")}
                      >
                        <a data-toggle="tab" href="#menu5">
                          Trading Bot Development
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>

                      <li
                        className={activeTab === "menu2" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu2")}
                      >
                        <a data-toggle="tab" href="#menu2">
                          Token Development{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>

                      <li
                        className={activeTab === "menu6" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu6")}
                      >
                        <a data-toggle="tab" href="#menu6">
                          Web3 Solutions
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "AI" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("AI")}
                      >
                        <a data-toggle="tab" href="#AI">
                          AI and ML Solutions{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                      <li
                        className={activeTab === "menu8" ? "active" : ""}
                        onMouseEnter={() => handleTabHover("menu8")}
                      >
                        <a data-toggle="tab" href="#menu8">
                          Game Development{" "}
                          <span>
                            <i className="ri-arrow-right-s-fill"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="col-lg-9">
                    <div className="tab-content">
                      <div
                        id="AI"
                        className={`tab-pane fade ${
                          activeTab === "AI" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/ai-and-ml-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/ai/ai.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>AI And ML development solutions</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/generative-ai-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/GenAI/gen-ai.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Generative AI Development</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="Listing"
                        className={`tab-pane fade ${
                          activeTab === "Listing" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/crypto-listing-agency"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/cryptolisting/listionment.png")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p> Crypto Listing Agency</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="Consulting"
                        className={`tab-pane fade ${
                          activeTab === "Consulting" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/vara-license-consultant"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/varalistion/palm-islands.png")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>VARA License Consultant</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="forex"
                        className={`tab-pane fade ${
                          activeTab === "forex" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/forex-trading-software-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/forex/forex-trading.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Forex Trading Software Development</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="home"
                        className={`tab-pane fade ${
                          activeTab === "home" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/white-label-cryptocurrency-exchange-software"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/bookmarks.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>White label Crypto Exchange</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/cryptocurrency-exchange-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/cryptocurrency.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Cryptocurrency Exchange Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/centralized-cryptocurrency-exchange-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/ai/decentralized.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>
                                  Centralized Cryptocurrency Exchange
                                  Development
                                </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/decentralized-cryptocurrency-exchange-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/decentralized.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Decentralized Exchange Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/p2p-cryptocurrency-exchange-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/peer-to-peer.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>P2P Exchange Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-payment-gateway-development-services"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/payment.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Crypto-Payment Gateway Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/cryptocurrency-exchange-script"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/script.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Cryptocurrency Exchange Clone Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-launchpad-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/launchpad.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Crypto Launchpad Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/cryptocurrency-mlm-software-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/decentralized.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Cryptocurrency MLM Software Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-otc-trading-platform-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/otc.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>OTC Platform Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-wallet-app-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/cryptowallet/wallet.webp")}
                                  className="icon_serveice"
                                  alt="Crypto Wallet Development Company"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Crypto Wallet Development Company</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="menu1"
                        className={`tab-pane fade ${
                          activeTab === "menu1" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/nft-marketplace-development-service"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/card.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>NFT Market Place Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/nft-game-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/game.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>NFT Gaming Development </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/metaverse-nft-marketplace-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/vr-goggles.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Metaverse NFT MarketPlace Development </p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="menu2"
                        className={`tab-pane fade ${
                          activeTab === "menu2" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/token-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/Tokendev.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Crypto Token Development </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/meme-coin-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/meme-coin.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Meme Coin Development Company </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/stablecoin-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/Home_ik/sto_token_logo.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p> Stablecoin Development Company</p>
                              </div>
                            </a>
                          </div>

                          <div className="col-lg-3">
                            <a
                              href="/ico-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/Home_ik/ico_token_logo.webp")}
                                  className="icon_serveice"
                                  alt="ICO Token Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>ICO Token Development</p>
                              </div>
                            </a>
                          </div>
                          {/* <div className="col-lg-3">
                            <a
                              href="/ieo-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/Home_ik/ieo_token_logo.webp")}
                                  className="icon_serveice"
                                  alt="IEO Token Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>IEO Token Development</p>
                              </div>
                            </a>
                          </div> */}
                          <div className="col-lg-3">
                            <a
                              href="/sto-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/Home_ik/sto_token_logo.webp")}
                                  className="icon_serveice"
                                  alt="STO Token Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>STO Token Development </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/central-bank-digital-currency-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/cbdc/cbdc_icon.webp")}
                                  className="icon_serveice"
                                  alt="Central Bank Digital Currency Development Company"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>
                                  Central Bank Digital Currency Development
                                  Company{" "}
                                </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/real-world-asset-token-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/RWA/property.webp")}
                                  className="icon_serveice"
                                  alt="real-world-asset-token-development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Real World Asset Token Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a href="/solana-meme-coin" className="header_menu">
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/solana_meme_coin/Images/sol 1.webp")}
                                  className="icon_serveice"
                                  alt="solana_meme_coin_development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Solana Meme Coin Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/semi-fungible-token-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/New_localbitcoin_clone/token-development-nav-logo.webp")}
                                  className="icon_serveice"
                                  alt="Semi Fungible Token Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Semi Fungible Token Development</p>
                              </div>
                            </a>
                          </div>
                          {/* <div className="col-lg-3">
                            <a
                              href="/meme-coin-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/memecoin/memecoin_icon.webp")}
                                  className="icon_serveice"
                                  alt="STO Token Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Meme Coin Development Company</p>
                              </div>
                            </a>
                          </div> */}
                        </div>
                      </div>
                      <div
                        id="menu3"
                        className={`tab-pane fade ${
                          activeTab === "menu3" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/defi-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/world.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Defi Development Company </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/defi-staking-platform-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/farming.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Defi Staking Platform </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/pancakeswap-clone-script-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/pancake.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Pancake Swap Clone Script</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="menu4"
                        className={`tab-pane fade ${
                          activeTab === "menu4" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/blockchain-based-carbon-credit-platform-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/carbon-dioxide.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>
                                  Blockchain Based Carbon Credit Platform
                                  Development
                                </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/dapp-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/decentralized.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>dApp Development Company</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/bitcoin-mining-software-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/mining/bitcoin.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Bitcoin Mining Software Development</p>
                              </div>
                            </a>
                          </div>

                          <div className="col-lg-3">
                            <a
                              href="/own-blockchain-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/blockchain.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Own Blockchain Development </p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/enterprise-blockchain-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/enter_price_blockchain_nav.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>
                                  Enterprise Blockchain Development Company{" "}
                                </p>
                              </div>
                            </a>
                          </div>

                          <div className="col-lg-3">
                            <a
                              href="/smart-contract-auditing-service-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/smart-contract.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Smart Contract Audit</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/dao-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/Dao.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>DAO Development Company</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/cardano-blockchain-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/cardano.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Cardano Blockchain Development Company</p>
                              </div>
                            </a>
                          </div>
                          {/* <div className="col-lg-3">
                            <a
                              href="/blockchain-social-media-platform-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/social-media.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>
                                  Blockchain Social Media Platform Development
                                </p>
                              </div>
                            </a>
                          </div> */}
                        </div>
                      </div>
                      <div
                        id="menu5"
                        className={`tab-pane fade ${
                          activeTab === "menu5" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/crypto-arbitrage-trading-bot"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/robot.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Arbitrage Bot Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-trading-bot-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/analysis.png")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Crypto Trading Bot Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-otc-trading-platform-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/otc.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>OTC Platform Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-smart-order-routing-services"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/smart-contracts.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Smart Order Routing Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-market-making-services"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/growth.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Crypto Market Making Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/mev-bot-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/EVM_bot/ethereum.webp")}
                                  className="icon_serveice"
                                  alt="mev-bot-development-company"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>MEV Bot Development Company</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-algo-trading-bot-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/algotrading/algo-trading-bot.webp")}
                                  className="icon_serveice"
                                  alt="Algo Trading Software Development Company"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Algo Trading Software Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/crypto-flash-loan-arbitrage-bot-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/Flash_loan/Flash-menu-icon.webp")}
                                  className="icon_serveice"
                                  alt="Flash Loan Arbitrage Bot Development<"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Flash Loan Arbitrage Bot Development</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="menu6"
                        className={`tab-pane fade ${
                          activeTab === "menu6" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/web3-development-solution"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/web3.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Web3 Solutions</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/metaverse-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/vr-goggles.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Metaverse Development Company</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="menu7"
                        className={`tab-pane fade ${
                          activeTab === "menu7" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/binance-clone-script-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/cryptocurrency.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Binance Clone Script</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/opensea-clone-script"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/card.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>OpenSea Clone Script</p>
                              </div>
                            </a>
                          </div>

                          <div className="col-lg-3">
                            <a
                              href="/rarible-clone-script"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/rarible_logo_icon.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Rarible Clone Script</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/coinbase-clone-script"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/coinbase_logo_ik.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Coinbase Clone script development</p>
                              </div>
                            </a>
                          </div>

                          <div className="col-lg-3">
                            <a
                              href="/paxful-clone-script-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/paxful/paxful_icon.webp")}
                                  className="icon_serveice"
                                  alt="Paxful
                                  Clone Script Developmen"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Paxful Clone Script Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/wazirx-clone-script-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/wazirx/wazirxicon.png")}
                                  className="icon_serveice"
                                  alt="WaziX
                                  Clone Script
                                  Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>WazirX Clone Script Development</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/local-bitcoin-clone"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/New_localbitcoin_clone/local-bitcoin-nav-logo.webp")}
                                  className="icon_serveice"
                                  alt="Localbitcoin Clone Script Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Localbitcoin Clone Script Development</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="menu8"
                        className={`tab-pane fade ${
                          activeTab === "menu8" ? "in active show" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <a
                              href="/crypto-casino-game-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/casino_game/Dice-navbar.webp")}
                                  className="icon_serveice"
                                  alt="Crypto Casino Game Development Company"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Crypto Casino Game Development Company</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/betfury-clone-script-development-company"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/betfury_icon.webp")}
                                  className="icon_serveice"
                                  alt="Betfury Clone Script Development Company"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Betfury Clone Script Development Company</p>
                              </div>
                            </a>
                          </div>
                          <div className="col-lg-3">
                            <a
                              href="/blockchain-game-development"
                              className="header_menu"
                            >
                              <div className="image_icon_link">
                                <img
                                  src={require("../image/HeaderMenu/game_block.webp")}
                                  className="icon_serveice"
                                  alt="Launchpad platform Development"
                                />
                              </div>
                              <div className="title_header_menu">
                                <p>Blockchain Game Development Company </p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
